'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Suspense } from 'react';
import SignOutButton from '@/app/_components/SignOutButton';
import { useCustomer } from '@/app/_lib/hooks';
const PageNav = t0 => {
  const $ = _c(46);
  const {
    pageKey
  } = t0;
  const {
    customer
  } = useCustomer();
  let t1;
  if ($[0] !== customer || $[1] !== pageKey) {
    t1 = customer && <div className="lg:hidden flex gap-4 overflow-x-auto pb-2 -mx-4 px-4"><Link href="/account" className={`text-xs font-medium whitespace-nowrap transition-colors ${pageKey == "dashboard" ? "text-primary" : "text-dark hover:text-primary"}`}>Your Account</Link><Link href="/account/order-history" className={`text-xs font-medium whitespace-nowrap transition-colors ${pageKey == "order_history" ? "text-primary" : "text-dark hover:text-primary"}`}>Orders</Link><SignOutButton className="text-xs font-medium whitespace-nowrap transition-colors text-dark hover:text-primary ml-auto">Sign Out</SignOutButton></div>;
    $[0] = customer;
    $[1] = pageKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <Suspense>{t1}</Suspense>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== customer || $[6] !== pageKey) {
    t3 = customer && <div className="mb-6"><div className="mb-10"><div className="font-medium text-xs">{customer.billing_first_name} {customer.billing_last_name}</div><SignOutButton className="text-xs underline text-nowrap">Sign Out</SignOutButton></div><Link className={`text-nowrap font-medium text-xs block mb-3 transition-colors ${pageKey == "dashboard" ? "text-primary" : ""}`} href="/account">Your Account</Link><Link className={`block mb-1 text-xs transition-colors ${pageKey == "order_history" ? "text-primary" : "text-light"}`} href="/account/order-history">Order History</Link></div>;
    $[5] = customer;
    $[6] = pageKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3) {
    t4 = <Suspense>{t3}</Suspense>;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-sm font-medium mb-3 pb-2 border-b-1 border-gray-8">Support</div>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `block mb-1 text-xs transition-colors ${pageKey == "about" ? "text-primary" : "text-light"}`;
  let t7;
  if ($[11] !== t6) {
    t7 = <Link className={t6} href="/about-hive">About hive</Link>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = `block mb-1 text-xs transition-colors ${pageKey == "sales_assistance" ? "text-primary" : "text-light"}`;
  let t9;
  if ($[13] !== t8) {
    t9 = <Link className={t8} href="/hive-sales-assistance">Sales Assistance</Link>;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = `block mb-1 text-xs transition-colors ${pageKey == "trade_program" ? "text-primary" : "text-light"}`;
  let t11;
  if ($[15] !== t10) {
    t11 = <Link className={t10} href="/hive-trade-program">Trade Program</Link>;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = `block mb-1 text-xs transition-colors ${pageKey == "samples" ? "text-primary" : "text-light"}`;
  let t13;
  if ($[17] !== t12) {
    t13 = <Link className={t12} href="/hive-samples">Swatch Samples</Link>;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = `block mb-1 text-xs transition-colors ${pageKey == "order_status" ? "text-primary" : "text-light"}`;
  let t15;
  if ($[19] !== t14) {
    t15 = <Link className={t14} href="/hive-order-status">Order Status</Link>;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const t16 = `block mb-1 text-xs transition-colors ${pageKey == "contact" ? "text-primary" : "text-light"}`;
  let t17;
  if ($[21] !== t16) {
    t17 = <Link className={t16} href="/contact-hive">Contact</Link>;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  const t18 = `block mb-1 text-xs transition-colors ${pageKey == "faq" ? "text-primary" : "text-light"}`;
  let t19;
  if ($[23] !== t18) {
    t19 = <Link className={t18} href="/hive-modern-frequently-asked-questions">FAQ</Link>;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  const t20 = `block mb-1 text-xs transition-colors ${pageKey == "store_policy" ? "text-primary" : "text-light"}`;
  let t21;
  if ($[25] !== t20) {
    t21 = <Link className={t20} href="/hive-modern-store-policy">Policies</Link>;
    $[25] = t20;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  const t22 = `block mb-1 text-xs transition-colors ${pageKey == "privacy_policy" ? "text-primary" : "text-light"}`;
  let t23;
  if ($[27] !== t22) {
    t23 = <Link className={t22} href="/hive-modern-privacy-policy">Privacy</Link>;
    $[27] = t22;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  const t24 = `block mb-8 text-xs transition-colors ${pageKey == "cookies_policy" ? "text-primary" : "text-light"}`;
  let t25;
  if ($[29] !== t24) {
    t25 = <Link className={t24} href="/hive-modern-cookies-policy">Cookie Policy</Link>;
    $[29] = t24;
    $[30] = t25;
  } else {
    t25 = $[30];
  }
  let t26;
  if ($[31] !== t11 || $[32] !== t13 || $[33] !== t15 || $[34] !== t17 || $[35] !== t19 || $[36] !== t21 || $[37] !== t23 || $[38] !== t25 || $[39] !== t4 || $[40] !== t7 || $[41] !== t9) {
    t26 = <div className="hidden lg:block">{t4}{t5}{t7}{t9}{t11}{t13}{t15}{t17}{t19}{t21}{t23}{t25}</div>;
    $[31] = t11;
    $[32] = t13;
    $[33] = t15;
    $[34] = t17;
    $[35] = t19;
    $[36] = t21;
    $[37] = t23;
    $[38] = t25;
    $[39] = t4;
    $[40] = t7;
    $[41] = t9;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] !== t2 || $[44] !== t26) {
    t27 = <><div className="w-full mb-6 lg:mb-0 lg:relative lg:w-[clamp(250px,22vw,345px)] lg:mr-8 flex flex-col items-start shrink-0"><nav className="w-full h-full relative">{t2}{t26}</nav></div></>;
    $[43] = t2;
    $[44] = t26;
    $[45] = t27;
  } else {
    t27 = $[45];
  }
  return t27;
};
export default PageNav;

/*
<div className="hidden lg:block min-w-32 mr-8 mb-12 lg:min-w-[175px]">
    <div className="mb-10 lg:mb-12">
        <div className="font-medium text-xs">{customer.billing_first_name} {customer.billing_last_name}</div>
        <SignOutButton className="text-xs underline text-nowrap">Sign Out</SignOutButton>
    </div>
    <Link className={` text-nowrap font-medium text-xs block mb-3 ${(pageKey == 'dashboard') ? 'text-primary' : ''}`} href="/account">My Dashboard</Link>
    <ul className="">
        <li><Link className={`block mb-1 text-xs text-light ${(pageKey == 'order_history') ? 'text-primary' : ''}`} href="/account/order-history">Order History</Link></li>
        <li><Link className={`block mb-1 text-xs text-light ${(pageKey == 'favorites') ? 'text-primary' : ''}`} href="/favorites">Favorites</Link></li>
        <li><Link className={`block mb-1 text-xs text-light ${(pageKey == 'address_book') ? 'text-primary' : ''}`} href="/account/address-book">Address Book</Link></li>
        <li><Link className={`block mb-1 text-xs text-light ${(pageKey == 'settings') ? 'text-primary' : ''}`} href="/account/settings">Settings</Link></li>
    </ul>
    
    <div className="font-medium text-xs mb-3 mt-6">Help</div>
    <Link className="block mb-1 text-xs text-light" href="/account/order-history">FAQ</Link>
    <Link className="block mb-1 text-xs text-light" href="/favorites">Policies</Link>
    <Link className="block mb-1 text-xs text-light" href="/account/preferences">Contact Us</Link>
</div>
*/